import * as yup from "yup";

export const createStructureSchema = yup.object({
  name: yup.string().required("Structure name is required"),
  acronym: yup.string(),
  denomination_structure_type_id: yup
    .string()
    .required("Structure type is required"),
  parent_id: yup.string().required("Parent is required"),
  email: yup.string().email("Invalid email format"),
  phone: yup.string(),
  p_o_box: yup.string(),
  country_id: yup.string(),
  region_id: yup.string(),
  zone_id: yup.string(),
  city_id: yup.string(),
  sub_city_id: yup.string(),
  woreda_id: yup.string(),
  kebele: yup.string(),
  house_number: yup.string(),
  specific_location: yup.string(),
  description: yup.string(),
  acceptTerms: yup
    .boolean()
    .oneOf([true], "You must accept the terms and conditions"),
  latitude: yup.string(),
  longitude: yup.string()
});
